import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Tabo from '../components/AppLayouts/Tabo';
import { makeStyles, useTheme } from '@material-ui/core/styles';

//Start Css Code ...
const useStyles = makeStyles((theme) => ({
  homeBlockMain:{
    padding: '10px', borderRadius: '5px',
    '@media only screen and (max-width: 3500px)': {
      width: '690px',
      maxWidth: '690px'
    },
    '@media only screen and (min-width: 3501px)': {
      width: '1200px',
      maxWidth: '1200px'
    },
  }
}))
//End Css Code ...

//Start Home component code ....
const Home = (props) => {
  const classes = useStyles();
  const catchAllStationsFromTabo = (data) => {
    props.callHome(data)
  };

  return (
    <React.Fragment>
      <CssBaseline />
      <Container maxWidth="sm" style={{  }} className={classes.homeBlockMain} data-testid="filterStationsPanel">
        <Typography component="div" style={{ backgroundColor: '#fff', minHeight: '360px' }}>
          <Tabo 
            callTabo={catchAllStationsFromTabo}
            geojsonNF={props.geojsonNF}
            ShowAllStations={props.ShowAllStations}
            loaderOff={props.loaderOff}
            loaderFunction={props.loaderFunction}
            loadSource = {props.loadSource}
            checked={props.checked}
          />
        </Typography>
      </Container>
    </React.Fragment>
  );
}
export default Home;
//End Home component code ....